import React, { createContext, useState } from "react";
import "./App.css";
import Chatbox from "./Components/Chatbox/Chatbox";
import Information from "./Components/Information/Information";
import States from "./Components/States/States";
import { loginPost } from "./API/API";

import ReactSwitch from "react-switch";
export const ThemeContext = createContext(null);
const axios = require("axios");

const login = async() =>{
  var token = document.getElementById("token")
  if (token.value != ""){

    const data = await loginPost(token.value);
    if(data.result === 200){
      document.cookie = `token=${data.access_token}`;
      var res = document.getElementById('loginRes');
      res.innerText = "Login Successfully."
    }
    else{
      var res = document.getElementById('loginRes');
      res.innerText = "Login Failed."
    }
  }
}

function search(event){
  if (event.keyCode == 13) { 
    event.preventDefault();
    login()
}
}

function App() {
  const [theme, setTheme] = useState("dark");
  const [type, setType] = useState();
  const [version, setVersion] = useState();
  const [information, setInformation] = useState();
  const [states, setStates] = useState();
  const [averageResponseTime, setAverageResponseTime] = useState(null);

  const toggleTheme = () => {
    setTheme((curTheme) => (curTheme === "dark" ? "light" : "dark"));
  };
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <div className="App" id="light">
        <div className="app-container">

  
          {states && <States states={states} />}
          <div className="chatbox-container">
            <h2>
              {type}v{version}
            </h2>
            <Chatbox
              setType={setType}
              setVersion={setVersion}
              // setInformation={setInformation}
              // setStates={setStates}
              // setAverageResponseTime={setAverageResponseTime}
            />
          </div>
          <div className="right">
            {information && <Information information={information} />}
            {averageResponseTime !== null && (
              <div className="responseTime">
                <p>Average Response Time: {averageResponseTime} seconds</p>
              </div>
            )}
            {/* <div className="switch">
              <label>{theme === "light" ? "light mode" : "dark mode"}</label>
              <ReactSwitch onChange={toggleTheme} checked={theme === "dark"} />
            </div> */}
          </div>
        </div>
      </div>
    </ThemeContext.Provider>
  );
}

export default App;
